import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import AuthRoutes from "./authRoutes";
import PublicRoutes from "./publicRoutes";

const RoutesContainer = () => {
  const token = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.defaults.baseURL = CONFIG.baseUrl;
    axios.defaults.withCredentials = true;
    if (token) {
      axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
    }
    setLoading(false);
  }, []);

  const router = createBrowserRouter([
    {
      path: "*",
      element: !token ? <PublicRoutes /> : <AuthRoutes />,
    },
  ], { basename: CONFIG.path });

  if (loading) return <div />;

  return (
    <RouterProvider router={router} />
  );
};

export default RoutesContainer;
